import { Fragment } from "react";
import { Flex, Text, Select, Radio, Button } from "@theorgchartdev/storybook";
import {
  sectionContainer,
  selectWithLabelStyle,
  sectionTitles,
  launchModes
} from "../../../../Navigation/Header/WebLinkMenu/WebLinkUtils";
import { GetWSMgr } from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";
import { appstrp } from "@coreapp/utils/appstrp";
import { enumFileMgrMode } from "@coreapp/constants";

const BuildLaunchModeRadioOptions = (currentLaunchMode, onChange) => {
  return (
    <Flex direction={"row"} gap={"8px"}>
      {launchModes.map(mode => (
        <Radio
          key={`launch-select-${mode}`}
          id={`launch-mode-radio-${mode}`}
          data-testid={`launch-mode-radio-${mode}`}
          label={appstr(mode)}
          value={mode}
          checked={mode === currentLaunchMode}
          onChange={() => onChange("launchMode", mode)}
        />
      ))}
    </Flex>
  );
};

const BuildBaseChartSelectOptions = (baseCharts, clickHandler) => {
  return baseCharts.map(chart => ({
    label: chart.name,
    value: chart.ID,
    clickHandler: target => clickHandler("chartID", target.value)
  }));
};

const BuildChartTypeSelectOptions = clickHandler => {
  return [
    {
      label: appstr("Base Chart"),
      value: 0,
      clickHandler: target => clickHandler("chartType", target.value),
      dataTestId: "launch-chart-type-basechart"
    },
    {
      label: appstr("Custom Chart"),
      value: 1,
      clickHandler: target => clickHandler("chartType", target.value),
      dataTestId: "launch-chart-type-customchart"
    }
  ];
};

export const LaunchConfigSection = ({ launchConfig, baseCharts, setUrlParamsMgr }) => {
  const SetLaunchFile = (dir, file) => {
    SetLaunchConfig("directory", dir);
    SetLaunchConfig("fileName", file);
    console.log(file);
  };

  const OpenFileMgr = () => {
    const wsmgr = GetWSMgr();
    wsmgr.DoFileMgr(enumFileMgrMode.selectcustomchart, {
      customOnSelect: SetLaunchFile,
      launchDirectory: launchConfig?.directory,
      currentSelectedFile: launchConfig?.fileName
    });
  };

  let fileText = launchConfig.fileName ? launchConfig.fileName : appstr("notset");
  let dirText = launchConfig.directory ? launchConfig.directory : appstr("notset");

  const SetLaunchConfig = (key, value) => {
    setUrlParamsMgr(prevState => ({
      ...prevState,
      launchConfig: { ...prevState.launchConfig, [key]: value }
    }));
  };

  return (
    <Fragment>
      <Flex {...sectionContainer}>
        <Text size={"small"} modifier={"bold"}>
          {appstr(sectionTitles.launchconfig)}
        </Text>
        {launchConfig.chartType === 1 ? (
          <Flex direction={"row"} gap={"8px"}>
            <Text size={"xsmall"}>{appstrp("filename", ": ") + fileText}</Text>
            <Text size={"xsmall"}>{appstrp("Directory", ": ") + dirText}</Text>
          </Flex>
        ) : null}
        {BuildLaunchModeRadioOptions(launchConfig.launchMode, SetLaunchConfig)}
        <Flex
          direction={"row"}
          gap={"4px"}
          alignItems={"flex-end"}
          justifyContent={"space-between"}
        >
          <Flex {...selectWithLabelStyle}>
            <Select
              label={appstr("launchto")}
              inputOnly={false}
              selectSize={"medium"}
              optionsSize={"small"}
              value={launchConfig.chartType}
              options={BuildChartTypeSelectOptions(SetLaunchConfig)}
            />
          </Flex>
          {launchConfig.chartType === 0 ? (
            <Flex width={"50%"}>
              <Select
                selectSize={"medium"}
                optionsSize={"small"}
                value={launchConfig.chartID}
                options={BuildBaseChartSelectOptions(baseCharts, SetLaunchConfig)}
                dataTestId={"weblink-launch-basechart-select"}
              />
            </Flex>
          ) : (
            <Button
              modifier={"secondary"}
              size={"small"}
              onClick={OpenFileMgr}
              dataTestId={"weblink-select-customchart-btn"}
            >
              {appstr("Select Custom Chart")}
            </Button>
          )}
        </Flex>
      </Flex>
    </Fragment>
  );
};
